import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=5f2e99c6&scoped=true&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=5f2e99c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e99c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VFlex,VLayout,VTextField})
